import { getCurrentSubscription } from '../data/stripe/subscription'
import { ITEM_TYPE } from '../data/itemType'
import LOG from '../logging/Logger'
import {
  MAX_FREE_TIER_AREAS,
  MAX_FREE_TIER_ATTACHMENTS,
  MAX_FREE_TIER_PROJECTS,
  MAX_FREE_TIER_TODOS,
  isUnderLimit
} from '../data/limits'

function isWithinLimit(getter, limit) {
  const allItems = getter()
  return isUnderLimit(allItems.length, limit)
}

export function isAtFreeLimit(todoCount, projectCount, areaCount) {
  const overFreeTier =
    !isUnderLimit(todoCount, MAX_FREE_TIER_TODOS) ||
    !isUnderLimit(projectCount, MAX_FREE_TIER_PROJECTS) ||
    !isUnderLimit(areaCount, MAX_FREE_TIER_AREAS)

  if (overFreeTier) {
    LOG.info('AT OR OVER FREE TIER: ', overFreeTier)
  }

  return overFreeTier
}

export async function hasSubscription() {
  const subEndDate = (await getCurrentSubscription()).subEndDate

  return subEndDate && new Date(subEndDate) >= Date.now()
}

export default async function enforceLimit(
  type,
  getter,
  openSettings,
  creator,
  setShowDialog,
  isOffline
) {
  LOG.debug('limitedCreateTodo entry')

  if (!isOffline && !(await hasSubscription())) {
    LOG.info('No Subscription')

    let withinLimit = true
    switch (type) {
      case ITEM_TYPE.TODO:
        withinLimit = isWithinLimit(getter, MAX_FREE_TIER_TODOS)
        break
      case ITEM_TYPE.PROJECT:
        withinLimit = isWithinLimit(getter, MAX_FREE_TIER_PROJECTS)
        break
      case ITEM_TYPE.AREA:
        withinLimit = isWithinLimit(getter, MAX_FREE_TIER_AREAS)
        break
      case ITEM_TYPE.ATTACHMENT:
        withinLimit = isWithinLimit(getter, MAX_FREE_TIER_ATTACHMENTS)
        break
      default:
        break
    }
    if (!withinLimit) {
      if (setShowDialog) {
        setShowDialog(false)
      }
      openSettings(true)
      LOG.info('At the limit for ', type.title)
      return
    }
  }

  return creator()
}
